import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.16242 7.99575L7.82483 9.33333L9.16242 10.6709C9.3905 10.899 9.3905 11.2677 9.16242 11.4958C9.04867 11.6095 8.89933 11.6667 8.75 11.6667C8.60067 11.6667 8.45133 11.6095 8.33758 11.4958L7 10.1582L5.66242 11.4958C5.54867 11.6095 5.39933 11.6667 5.25 11.6667C5.10067 11.6667 4.95133 11.6095 4.83758 11.4958C4.6095 11.2677 4.6095 10.899 4.83758 10.6709L6.17517 9.33333L4.83758 7.99575C4.6095 7.76767 4.6095 7.399 4.83758 7.17092C5.06567 6.94283 5.43433 6.94283 5.66242 7.17092L7 8.5085L8.33758 7.17092C8.56567 6.94283 8.93433 6.94283 9.16242 7.17092C9.3905 7.399 9.3905 7.76767 9.16242 7.99575ZM14 4.08333V11.0833C14 12.6916 12.6916 14 11.0833 14H2.91667C1.30842 14 0 12.6916 0 11.0833V4.08333C0 2.47508 1.30842 1.16667 2.91667 1.16667H3.5V0.583333C3.5 0.26075 3.76133 0 4.08333 0C4.40533 0 4.66667 0.26075 4.66667 0.583333V1.16667H9.33333V0.583333C9.33333 0.26075 9.59467 0 9.91667 0C10.2387 0 10.5 0.26075 10.5 0.583333V1.16667H11.0833C12.6916 1.16667 14 2.47508 14 4.08333ZM1.16667 4.08333V4.66667H12.8333V4.08333C12.8333 3.1185 12.0482 2.33333 11.0833 2.33333H2.91667C1.95183 2.33333 1.16667 3.1185 1.16667 4.08333ZM12.8333 11.0833V5.83333H1.16667V11.0833C1.16667 12.0482 1.95183 12.8333 2.91667 12.8333H11.0833C12.0482 12.8333 12.8333 12.0482 12.8333 11.0833Z"
      fill="#151718"
    />
  </svg>
);

const UnscheduleIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default UnscheduleIcon;
